import React, { useState } from 'react';
import { Avatar, Button, Modal, Row, Space, Tooltip, Typography } from 'antd';
import { CloudDownloadOutlined, DownloadOutlined, InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { useAxios } from '../../service/useAxios';
import { downloadBlob } from '../common-constants';
import moment from 'moment';
const { Text } = Typography;

export const useExcelExporter = (entityName, selectedRowKeys) => {
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const axiosInstance = useAxios();

  const onExport = () => {
    setExportModalVisible(true);
  }

  const onExportSelected = () => {
    if (selectedRowKeys.length > 0) {
      exportData({
        idList: selectedRowKeys.join(',')
      });
    }
  }

  const onExportAll = () => {
    exportData({
      all: true
    });
  }

  const exportData = (params) => {
    setExportLoading(true);
    axiosInstance.request({
      url: '/api/'+ entityName +'/excel',
      params: params,
      method: 'GET',
      responseType: 'arraybuffer',
    }).then((response) => {
      downloadBlob(response.data, entityName + '_' + moment().format('DD_MM_YYYY-HH_mm_ss') +'.xlsx')
    }).finally(() => setExportLoading(false));
  }

  const excelExportModal = (
    <Modal
      title="Export Data to Excel File"
      visible={exportModalVisible}
      footer={null}
      onCancel={() => setExportModalVisible(false)}
    >
      <Row justify='center'>
        <Avatar
          size={96}
          icon={exportLoading ? <SyncOutlined spin />: <CloudDownloadOutlined /> }
        />
      </Row>
      <Row justify='center' style={{ marginTop: '2em' }}>
        <Space>
          <Button
            disabled={exportLoading}
            onClick={onExportAll}
            icon={<DownloadOutlined />}
          >
            All Items
          </Button>
          <Button
            disabled={selectedRowKeys.length <= 0 || exportLoading}
            onClick={onExportSelected}
            icon={<DownloadOutlined />}
          >
            Selected Items
          </Button>
        </Space>
      </Row>
      {exportLoading &&
        <Row justify='center' style={{ marginTop: '1em' }}>
          <Text type="secondary">
            File is being prepared...
          </Text>
          <Text type="secondary">
            Please do not close the page until operation is completed.
          </Text>
          <Text type="secondary">
            It might take up to few minutes. {" "}
            <Tooltip title="You can choose smaller set of items for faster downloads">
              <InfoCircleOutlined/>
            </Tooltip>
          </Text>
        </Row>
      }
    </Modal>
  );

  return {
    excelExportModal,
    onExport,
  }
};
